import { render, staticRenderFns } from "./RespostaCadastroProdutoReplicarPreco.vue?vue&type=template&id=4dc58c5e"
import script from "./RespostaCadastroProdutoReplicarPreco.vue?vue&type=script&lang=js"
export * from "./RespostaCadastroProdutoReplicarPreco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports